import * as React from 'react'

export interface IDrawerState {
  drawerMounted: boolean
}

class Drawer extends React.Component<{}, IDrawerState> {
  private DrawerRef = React.createRef<HTMLDivElement>()
  public constructor(props: {}) {
    super(props)
    this.state = {
      drawerMounted: false,
    }
  }
  public componentDidMount() {
    this.setState({ drawerMounted: true })
    this.DrawerRef.current.focus()
  }
  public componentWillUnmount() {
    this.setState({ drawerMounted: false })
  }
  public render() {
    const drawerMounted: boolean = this.state.drawerMounted

    return (
      <div
        className={drawerMounted ? 'Drawer Drawer--mounted' : 'Drawer'}
        ref={this.DrawerRef}
        tabIndex={-1}
      >
        {this.props.children}
      </div>
    )
  }
}

export default Drawer



// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.tsx